import { getScoreClass } from "../../../../functions/functions";

export default function ScoreBaseballComponent({ item, norm }) {
  const { left_class, right_class, class: gameClass, sport, left_score, right_score } = item;
  // Validar si hay datos de linescores para AMFO (BASK puede usar scores directos)
  if (sport === 'AMFO') {
    const sportData = item.football_data;
    const leftLinescores = sportData?.left_stats?.linescores;
    const rightLinescores = sportData?.right_stats?.linescores;

    if (!leftLinescores || !rightLinescores) {
      return <div className="card-body-right"></div>;
    }
  }

  const getTeamScores = (prefix) => {
    if (sport === 'AMFO' || sport === 'BASK') {
      const sportData = sport === 'AMFO' ? item.football_data : item.basketball_data;
      const linescores = sportData?.[`${prefix}_stats`]?.linescores || [];
      const finalScore = prefix === 'left' ? left_score : right_score;

      // Para BASK sin linescores, usar solo el score final
      if (sport === 'BASK' && linescores.length === 0) {
        return [norm(finalScore || "0")];
      }

      // Para AMFO o BASK con linescores
      const sortedLinescores = linescores.sort((a, b) => a.period - b.period);
      const scores = sortedLinescores.map(ls => norm(ls.score || "0"));
      scores.push(norm(finalScore || "0")); // Agregar total al final

      return scores;
    }
    if (sport === 'BASE') {
      const stats = item.baseball_data?.[`${prefix}_stats`];
      return [
        norm(stats?.linescoreTotals?.runs || "0"),
        norm(stats?.linescoreTotals?.hits || "0"),
        norm(stats?.linescoreTotals?.errors || "0")
      ];
    }
    return [
      norm(item[`${prefix}_runs`] || item[`${prefix}_score`] || "0"),
      norm(item[`${prefix}_hits`] || "0"),
      norm(item[`${prefix}_errors`] || "0")
    ];
  };

  const renderScoreRow = (scores, teamClass, prefix) => {
    // Generar scoreTypes dinámicamente
    let scoreTypes;
    if (sport === 'AMFO' || sport === 'BASK') {
      const periodsCount = scores.length - 1; // -1 porque el último es el total
      scoreTypes = [];
      for (let i = 1; i <= periodsCount; i++) {
        scoreTypes.push(`q${i}`);
      }
      scoreTypes.push('E'); // Agregar total al final
    } else {
      scoreTypes = ['r', 'h', 'e'];
    }

    // Verificar posesión para AMFO
    const hasPossession = sport === 'AMFO' && item.football_data?.[`${prefix}_stats`]?.has_possession;

    // Para AMFO, determinar cuántos períodos mostrar basado en last_move.period
    let maxIndex;
    if (sport === 'AMFO') {
      const currentPeriod = item.football_data?.last_move?.period || scores.length - 1;
      const maxPeriodsCount = scores.length - 1; // -1 porque el último es el total
      maxIndex = Math.min(currentPeriod, maxPeriodsCount);
    } else {
      // Para BASK y BASE, mostrar todos los scores
      maxIndex = scores.length;
    }

    return (
      <div className="card-body-right-tres">

        {sport === 'AMFO' && gameClass === 'clarosports-in-progress-game' && (hasPossession ? <div className="possession-icon"></div> : <div className="possession-icon-null"></div>)}
        {scores.map((score, index) => {
          const scoreType = scoreTypes[index];
          // Para AMFO: mostrar solo hasta currentPeriod + total final
          // Para BASK y BASE: mostrar todos los scores
          const isVisible = sport === 'AMFO' 
            ? (index < maxIndex || index === scores.length - 1) // AMFO: períodos actuales + total
            : true; // BASK y BASE: mostrar todos
          const scoreClass = getScoreClass(`score-${scoreType}`, teamClass, gameClass);
          const finalClass = `${scoreClass}`;

          return (
            <span key={scoreType} className={finalClass}>
              {isVisible ? score : '-'}
            </span>
          );
        })}
      </div>
    );
  };

  const leftScores = getTeamScores('left');
  const rightScores = getTeamScores('right');
  
  return (
    <div className={gameClass === 'clarosports-finished-game' ? 'card-body-right mr-finished' : sport === 'BASK' ? "card-body-right mr-finished" : 'card-body-right'}>
      <div className={'card-body-right-tres'}>
        {sport === 'AMFO' && gameClass === 'clarosports-in-progress-game' && <div className="possession-icon-null"></div>}
        {(() => {
          // Generar headers dinámicamente
          let headers, scoreTypes;
          if (sport === 'AMFO' || sport === 'BASK') {
            const sportData = sport === 'AMFO' ? item.football_data : item.basketball_data;
            const linescores = sportData?.left_stats?.linescores || [];
            
            headers = [];
            scoreTypes = [];

            // Para BASK sin linescores, solo mostrar Total
            if (sport === 'BASK' && linescores.length === 0) {
              headers = ['T'];
              scoreTypes = ['E'];
            } else {
              // Para AMFO o BASK con linescores
              const sortedLinescores = linescores.sort((a, b) => a.period - b.period);
              
              sortedLinescores.forEach((ls, index) => {
                headers.push(ls.period.toString());
                scoreTypes.push(`q${index + 1}`);
              });

              headers.push('T'); // Agregar total al final
              scoreTypes.push('E');
            }
          } else {
            headers = ['R', 'H', 'E'];
            scoreTypes = ['r', 'h', 'e'];
          }

          return headers.map((header, index) => {
            const headerClass = `score-header score-header-${scoreTypes[index]}`;
            return (
              <span key={header} className={headerClass}>{header}</span>
            );
          });
        })()}
      </div>
      {renderScoreRow(leftScores, left_class, 'left')}
      {renderScoreRow(rightScores, right_class, 'right')}
    </div>
  );
}